import styled from 'styled-components';
import { LinkSet } from '../data';

interface Props {
  linkSet: LinkSet;
  auctionDetail?: any;
}

function OutLinkSection({ linkSet, auctionDetail }: Props) {
  const links = [
    {
      img: '/assets/images/icon/eum.svg',
      title: '토지이용계획열람',
      link: linkSet.landUsePlanLink,
    },
    {
      img: '/assets/images/icon/icon_court.svg',
      title: '법원경매정보',
      link: 'https://www.courtauction.go.kr/pgj/index.on',
    },
    {
      img: '/assets/images/icon/naver.svg',
      title: '네이버 부동산',
      link: auctionDetail?.naver,
    },
    {
      img: '/assets/images/icon/asil.svg',
      title: '아실',
      link: auctionDetail?.asil,
    },
    {
      img: '/assets/images/icon/hogangnono.svg',
      title: '호갱노노',
      link: auctionDetail?.hogangnono,
    },
  ];

  return (
    <Container id="유용한 사이트">
      <Title>유용한 사이트</Title>
      <Content>
        {links.map((item) => (
          <ItemButton
            key={item.title}
            $disable={!item.link}
            onClick={() => {
              if (item.link) {
                window.open(item.link);
              }
            }}
          >
            <ItemTitle>
              <img src={item.img} alt="" />
              {item.title}
            </ItemTitle>
            <img alt="방문하기" src="/assets/images/icon/open-in-new.svg" />
          </ItemButton>
        ))}
      </Content>
    </Container>
  );
}

export default OutLinkSection;

const Container = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  background: #fff;
`;

const Title = styled.div`
  flex: 1 0 0;
  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const Content = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, 1fr);
  align-self: stretch;
`;

const ItemButton = styled.div<{ $disable?: boolean }>`
  display: flex;
  padding: 10px 12px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  background: rgba(2, 32, 71, 0.05);
  opacity: ${({ $disable }) => ($disable ? 0.2 : 1)};
`;

const ItemTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(0, 12, 30, 0.8);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;

  & > img {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    aspect-ratio: 1/1;
    border-radius: 4px;
  }
`;
